<template>
  <div class="wrapper">
    <div class="back" @click="$router.go(-1)"></div>
    <h1>Change Password</h1>
  <div class="input">
        <p>New Password</p>
        <div class="input-container">
      <input type="email" placeholder="New Password" v-model="newPassword" />
      </div>
      </div>

      <h3 class="title">Password Requirements:</h3>
      <div class="box-wrap"> <p>A mix of upperercase and lowercase letters.</p></div>
      <div class="box-wrap"> <p>Include at least one number and one symbol.</p></div>
      <div class="box-wrap"> <p>At least 8 characters long.</p></div>

      <button class="button buttonDefault" @click="changePassword">Confirm</button>

  </div>

</template>

<script>
import { Auth } from 'aws-amplify';

export default {
  data() {
    return {
      newPassword: '',
    };
  },
  computed: {
    user() {
      return this.$route.params.user;
    },
  },
  methods: {

    changePassword() {
      if (this.newPassword.length > 1) {
        Auth.completeNewPassword(this.user, this.newPassword).then((user) => {
          this.$store.commit('setToken', user);
          this.$store.commit('setLoggedIn', true);
        }).then(() => {
          this.$router.push({ name: 'Cameras' });
          this.$store.dispatch('addNotification', {
            type: 'green',
            title: 'Password Set!',
            comment: '',
          });
        }).catch((e) => {
          console.log(e);
          this.$store.dispatch('addNotification', {
            type: 'red',
            title: 'Failure!',
            comment: e.message,
          });
        });
      }
    },
  },

};
</script>

<style scoped>

.input {
  padding-left: 10px;
  padding-right: 10px;
}

button {
  margin-top: 50px;
  width: 126px;
  height: 63px;
  background-color: var(--surface-dark);
  border-radius: var(--border-radius);
  font-weight: 500;
  font-size: 20px;
}

.input:nth-of-type(2) {
  margin-top: 50px;
}

h3 {
    margin-top: 20px;

}
.box-wrap {
  display: flex;
  margin: 20px 30px 0;
}
.box-wrap:first-of-type {
  margin-top: 10px;
}
.box {
  margin-right: 10px;
  width: 22px;
  height: 22px;
  background-color: black;
  border-radius: 100px;
}
.wrapper {
   margin-top: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
h1 {
     font-weight: 500;
    font-size: 24px;
}
</style>
